import React from 'react';

// Components


import MarriageModal from '@components/lce/modals/MarriageModal';

// Constants

import { lceModalTypes as MODAL_TYPES } from '@constants/lce/modals/lceModalTypes';


/**
 *
 * @param {Object} props - contains "modal" props from Redux Store
 * @returns {React.Component} - modal layout and needed content for Modal
 *
 */
const LceModalContainer = props => {

    let {
        modal,
        modal: {
            modalType
        },
        ...restProps
    } = props;


    const getModal = () => {
        switch (modalType) {

            case MODAL_TYPES.MARRIAGE_MODAL:
                return <MarriageModal {...{ modal, ...restProps }}/>;
        }
    };

    return getModal();
};

export default LceModalContainer;
